export default "__VITE_ASSET__b7f3dca1__"